(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initHeader(root) {
      if (!root || root.dataset.headerInitialized === 'true') return;
      root.dataset.headerInitialized = 'true';

      var mobileToggle = root.querySelector('[data-mobile-toggle]');
      var mobileMenu = root.querySelector('[data-mobile-menu]');
      var mobileOverlay = root.querySelector('[data-mobile-overlay]');
      var mobileClose = root.querySelector('[data-mobile-close]');
      var searchToggle = root.querySelector('[data-search-toggle]');
      var searchDrawer = root.querySelector('[data-search-drawer]');
      var searchClose = root.querySelector('[data-search-close]');
      var searchInput = searchDrawer ? searchDrawer.querySelector('input[type="search"]') : null;

      function openMobileMenu() {
        mobileMenu.hidden = false;
        mobileOverlay.hidden = false;
        requestAnimationFrame(function () {
          mobileMenu.setAttribute('data-open', '');
        });
        mobileToggle.setAttribute('aria-expanded', 'true');
        document.body.style.overflow = 'hidden';
      }

      function closeMobileMenu() {
        mobileMenu.removeAttribute('data-open');
        mobileToggle.setAttribute('aria-expanded', 'false');
        document.body.style.overflow = '';
        setTimeout(function () {
          mobileMenu.hidden = true;
          mobileOverlay.hidden = true;
        }, 250);
      }

      if (mobileToggle) {
        mobileToggle.addEventListener('click', function () {
          var isOpen = mobileToggle.getAttribute('aria-expanded') === 'true';
          if (isOpen) {
            closeMobileMenu();
          } else {
            openMobileMenu();
          }
        });
      }

      if (mobileClose) mobileClose.addEventListener('click', closeMobileMenu);
      if (mobileOverlay) mobileOverlay.addEventListener('click', closeMobileMenu);

      root.querySelectorAll('[data-accordion-toggle]').forEach(function (button) {
        button.addEventListener('click', function () {
          var row = button.closest('.mobile-menu__item');
          var panel = row.querySelector('[data-accordion-panel]');
          var isOpen = button.getAttribute('aria-expanded') === 'true';
          button.setAttribute('aria-expanded', String(!isOpen));
          panel.hidden = isOpen;
        });
      });

      function openSearch() {
        searchDrawer.hidden = false;
        searchToggle.setAttribute('aria-expanded', 'true');
        if (searchInput) searchInput.focus();
      }

      function closeSearch() {
        searchDrawer.hidden = true;
        searchToggle.setAttribute('aria-expanded', 'false');
      }

      if (searchToggle) {
        searchToggle.addEventListener('click', function () {
          var isOpen = searchToggle.getAttribute('aria-expanded') === 'true';
          if (isOpen) {
            closeSearch();
          } else {
            openSearch();
          }
        });
      }

      if (searchClose) searchClose.addEventListener('click', closeSearch);

      root.querySelectorAll('[data-menu-item].has-mega-menu').forEach(function (item) {
        var toggle = item.querySelector('[data-mega-toggle]');

        toggle.addEventListener('click', function (event) {
          if (window.matchMedia('(hover: hover) and (min-width: 990px)').matches) return;
          event.preventDefault();
          var isOpen = item.classList.contains('is-open');

          root.querySelectorAll('[data-menu-item].is-open').forEach(function (openItem) {
            openItem.classList.remove('is-open');
            var t = openItem.querySelector('[data-mega-toggle]');
            if (t) t.setAttribute('aria-expanded', 'false');
          });

          if (!isOpen) {
            item.classList.add('is-open');
            toggle.setAttribute('aria-expanded', 'true');
          }
        });
      });

      document.addEventListener('click', function (event) {
        if (!root.contains(event.target)) {
          root.querySelectorAll('[data-menu-item].is-open').forEach(function (openItem) {
            openItem.classList.remove('is-open');
            var t = openItem.querySelector('[data-mega-toggle]');
            if (t) t.setAttribute('aria-expanded', 'false');
          });
        }
      });

      document.addEventListener('keydown', function (event) {
        if (event.key !== 'Escape') return;
        closeMobileMenu();
        closeSearch();
        root.querySelectorAll('[data-menu-item].is-open').forEach(function (openItem) {
          openItem.classList.remove('is-open');
        });
      });

      window.addEventListener('resize', function () {
        if (window.innerWidth >= 990) {
          closeMobileMenu();
        }
      });
    }

    document.querySelectorAll('[data-header-section]').forEach(initHeader);

    document.addEventListener('shopify:section:load', function (event) {
      var root = event.target.querySelector('[data-header-section]');
      if (root) initHeader(root);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
